function StepperProgressBarMobileNextLineFp() {
    return <svg width="75" height="163" viewBox="0 0 75 163" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66.3789 1L66.3789 88.5" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M60.3789 74.5L66.2122 79.1667L72.0456 74.5" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M66.3789 64.5L66.3789 162" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M0.857422 1L30.9879 1" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M30.9883 1L61.1187 1" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M0.857422 162L30.9879 162" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M30.9883 162L61.1187 162" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
  </svg>;
}

export default StepperProgressBarMobileNextLineFp;